import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appFilterNumbers]'
})
export class FilterNumbersDirective {
  @Input() separatorEnabled: boolean = false;
  @Input() formatCpf: boolean = false;
  @Input() formatCodBTG: boolean = false;
  @Input() formatCnpj: boolean = false;
  @Input() maxValue: number | null = null;
  @Input() hasDecimal: boolean = false;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    let initialValue: string = this.el.nativeElement.value.replace(/\D/g, ''); // Remove tudo que não é dígito

    console.log(this.maxValue)
    if (this.maxValue !== null) {
      const numericValue: number = parseInt(initialValue, 10);
      if (!isNaN(numericValue) && numericValue > this.maxValue) {
        initialValue = this.maxValue.toString();
      }
    };

    if (this.formatCpf) {
      initialValue = initialValue.padStart(11, '0'); // Garante que tenha 11 caracteres, preenchendo com '0' à esquerda, se necessário
      initialValue = initialValue.substring(initialValue.length - 11); // Pega apenas os 11 primeiros caracteres
      initialValue = initialValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'); // Formata para 000.000.000-00
    } else if (this.formatCnpj) {
      initialValue = initialValue.padStart(14, '0'); // Garante que tenha 14 caracteres, preenchendo com '0' à esquerda, se necessário
      initialValue = initialValue.substring(0, 14); // Pega apenas os 14 primeiros caracteres
      initialValue = initialValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); // Formata para 00.000.000/0000-00
    } else if (this.separatorEnabled) {
      initialValue = initialValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Adiciona a máscara de separador de milhar
    }; 

    if (this.formatCodBTG) {
      initialValue = initialValue.padStart(9, '0');
      initialValue = initialValue.substring(initialValue.length - 9); // Pega apenas os 9 primeiros caracteres
    };
    
    if (this.hasDecimal) {
      if (parseInt(initialValue, 10) < 100 && this.hasDecimal) {
        initialValue = initialValue.padStart(3, '0');
      };
      if (initialValue.length > 3) {
        initialValue = initialValue.replace(/^0+/, '');
        initialValue = initialValue.padStart(3, '0');
      };
      initialValue = initialValue.slice(0, -2) + ',' + initialValue.slice(-2);
    }

    this.el.nativeElement.value = initialValue;
  }
}
